function validateField(field) {
    const errorElement = document.getElementById(`${field.name}-error`);
    
    if (field.required && !field.value.trim()) {
      errorElement.textContent = 'Este campo es requerido';
      return false;
    }
    
    if (field.type === 'email' && !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(field.value)) {
      errorElement.textContent = 'Ingresa un email válido';
      return false;
    }
    
    if (field.name === 'phone' && !/^[0-9]{7,15}$/.test(field.value)) {
      errorElement.textContent = 'Solo números (7-15 dígitos)';
      return false;
    }
    
    if (field.name === 'name' && !/^[A-Za-zÁ-Úá-úñÑ\s]{2,50}$/.test(field.value)) {
      errorElement.textContent = 'Solo letras y espacios';
      return false;
    }
    
    if (field.type === 'checkbox' && !field.checked) {
      errorElement.textContent = 'Debes aceptar los términos para continuar';
      return false;
    }
    
    errorElement.textContent = '';
    return true;
}


// Función para verificar validez del formulario
function checkFormValidity(form) {
  let isValid = true;
  const submitBtn = form.querySelector('button[type="submit"]');
  
  form.querySelectorAll('input[required], textarea[required], select[required]').forEach(input => {
    if (!input.checkValidity()) isValid = false;
  });
  
  // Verificar términos y condiciones
  if (!form.terms.checked) isValid = false;
  
  // Cambiar color del botón
  
  submitBtn.style.backgroundColor = isValid ? '#88FCE4' : '#D9D9D9';
  submitBtn.disabled = !isValid;
}

async function submitForm(form, formName){    
    // Validar todos los campos
    let isValid = true;
    form.querySelectorAll('input[required], textarea[required]').forEach(input => {
      if (!validateField(input)) isValid = false;
    });
    
    if (!isValid) return;
    
    // Mostrar loader
    const submitBtn = form.querySelector('button[type="submit"]');
    submitBtn.disabled = true;
    submitBtn.innerHTML = 'Enviando...';
    
    try {
      // Obtener datos del formulario
      let formData = {
        fullName: form.name.value.trim(),
        email: form.email.value.trim(),
        phoneNumber: form.phone.value.trim(),
        message: form.message.value.trim(),        
        
      };

      if(formName === 'Pqr'){
              
        const typePqrsArr = form.pqrsType.value.split("|");
        formData = {
            ...formData,
            typeId: typePqrsArr[0],
            subject: form.subject.value,
            typePqrs: typePqrsArr[1]
        }
      } else if( formName === 'Contact' ){
        formData = {
            ...formData,
            city: form.city.value
        }
      }      
      
      const response = await ApiService.submitForm(formData, formName);   
      
      // Mostrar resultado en modal
      const dataModal = {
        title: "Envío exitoso",
        confirmText: "Aceptar",
        text1: "El formulario fue enviado exitosamente.",
        text2: "¡Pronto nos pondremos en contacto!"
      }

      AvisosAlerts.showModal(dataModal);    
            
      if (response.ok){
        form.reset();
        submitBtn.style.backgroundColor = '#D9D9D9';
        submitBtn.disabled = true;
      } 
      
    } catch (error) {
      console.error('Error:', error);
      const dataModal = {
        title: "Error envío",
        confirmText: "Volver",
        text1: "Tuvimos un error durante el envío del formulario.",
        text2: "¡Por favor vuelve a intentarlo!"
      }

      AvisosAlerts.showModal(dataModal);      
      
    } finally {
      submitBtn.disabled = false;
      submitBtn.innerHTML = 'Enviar <svg xmlns="http://www.w3.org/2000/svg" fill="none" class="icon icon-arrow" viewBox="0 0 14 10"><path fill="currentColor" fill-rule="evenodd" d="M8.537.808a.5.5 0 0 1 .817-.162l4 4a.5.5 0 0 1 0 .708l-4 4a.5.5 0 1 1-.708-.708L11.793 5.5H1a.5.5 0 0 1 0-1h10.793L8.646 1.354a.5.5 0 0 1-.109-.546" clip-rule="evenodd"></path></svg>';
    }
  
}